// extracted by mini-css-extract-plugin
export var callCard = "_qb-0";
export var callMessageButton = "_qb-1";
export var helpIcon = "_qb-3";
export var helpIconContainer = "_qb-4";
export var verticalDivider = "_qb-2";